module.exports = __webpack_public_path__ + "images/9b01c367cdd02bbc43d17d9b02e27ae5.svg";